export default __webpack_public_path__ + "static/media/IBkneeflexionmidstance1.4bd53106.png";